<template>
  <ItemListCollectionWrapper
    collectionModule="CloudInsightsAccountsCollection"
    defaultSortBy="createdAt"
    :refreshKey="refreshKey"
    :rowsPerPageLocalStorageKey="rowsPerPageLocalStorageKey"
  >
    <template v-slot="slotProps">
      <ItemListPagination
        :class="$style.itemList"
        :columns="$options.columns"
        :currentPageNum="slotProps.currentPageNum"
        :isLoading="slotProps.loading"
        :itemComponent="itemComponent"
        :rowsPerPage="slotProps.rowsPerPage"
        :showEmptyState="slotProps.showEmptyState || !slotProps.tableData.length"
        :sortBy="slotProps.sortBy"
        :sortDirection="slotProps.sortDirection"
        :tableData="slotProps.tableData"
        :totalCount="slotProps.totalCount * 0"
      >
        <template v-slot:toolbar>
          <ManageAccountItemListToolbar
            @addAccountButtonClick="handleAddAccountButtonClick"
          />
        </template>
      </ItemListPagination>
      <div
        v-if="showNoItemsMessage(slotProps.tableData.length)"
        :class="$style.emptyText"
      >
        <span>{{ $options.noItemsMsg }}</span>
      </div>
    </template>
  </ItemListCollectionWrapper>
</template>

<script>
import { ItemListPagination, Types } from '@jumpcloud/ui-components';
import { columnsData } from 'client/CloudInsights/constants/ManageAccountConstants';
import { mapState } from 'vuex';
import Constants, {
  ItemTypeConsts,
  LocalStorageConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import ItemListCollectionWrapper from 'client/components/ItemList/ItemListCollectionWrapper.vue';
import LocalStorageService from 'client/util/LocalStorageService';
import ManageAccountItemListToolbar from 'client/CloudInsights/ManageAccounts/ManageAccountItemListToolbar.vue';
import ManageAccountItemRow from 'client/CloudInsights/ManageAccounts/ManageAccountItemRow.vue';

const { noResultsIllustration } = Constants;
const { cloudInsightsAccountsRowsPerPage } = LocalStorageConsts;
const cloudInsightsAccountsModule = StoreModuleMap[ItemTypeConsts.cloudInsightsAccounts];
const { Column } = Types;
const columns = columnsData.map(columnConfig => Column(columnConfig));
const noItemsMsg = 'Once your accounts have been activated, you will be able to manage them here.';

export default {
  name: 'ManageAccountTable',
  components: {
    ItemListCollectionWrapper,
    ItemListPagination,
    ManageAccountItemListToolbar,
  },

  LocalStorageService,
  columns,
  noItemsMsg,

  props: {
    refreshKey: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapState(cloudInsightsAccountsModule, ['isLoading']),
  },

  created() {
    this.itemComponent = ManageAccountItemRow;
    this.noResultsIllustration = noResultsIllustration;
    this.rowsPerPageLocalStorageKey = cloudInsightsAccountsRowsPerPage;
  },

  methods: {
    handleAddAccountButtonClick() {
      this.$emit('addAccountButtonClick');
    },

    showNoItemsMessage(count) {
      return !count && !this.isLoading;
    },
  },
};
</script>

<style module scoped>
.itemList /deep/ footer {
  color: #fff;
}

.emptyText {
  border-bottom: 1px solid var(--jc-border-color);
  font-size: var(--jcBody);
  padding: var(--jc-spacer-medium);
}
</style>
